import React from 'react';
import {  Routes, Route } from 'react-router-dom';
import Home from '../Home';  // Ensure this path is correct
import Product from '../Product';
import About from '../About';

const Approuter = () => {
    return (
        
            <Routes>
            
                <Route path="/" element={<Home />} />
                <Route path="/Product" element={<Product/>} />
                <Route path="/About" element={<About />} />
            </Routes>
        
    );
};

export default Approuter;